import PropTypes from 'prop-types'
import React from 'react'
import RadioField from '../../molecules/fields/RadioField'
import * as validations from '../../../utils/validations'
import useTextValidation from '../../../hooks/useTextValidation'
import { useTranslation } from 'react-i18next'
import { getLabelWithManualRequest } from '../../../configs/formsConfig'

const RadioCitizenField = ({
  name,
  index,
  payload,
  required,
  manualRequest = false,
  disabled = false,
  margin,
  onChange,
  optional
}) => {
  const baseLabel = index ? `${index}. ${payload?.label}` : payload?.label
  const label = getLabelWithManualRequest(baseLabel, manualRequest)

  const { t } = useTranslation(['form_field_options'])
  const otherLabel = t('radio_checkbox_button_other', { ns: 'form_field_options' })
  const options = (payload?.alternatives || []).map(o => ({
    value: o.label,
    label: o.type === 'other' ? otherLabel : o.label,
    type: o.type
  }))
  const translationText = useTextValidation()
  return (
    <RadioField
      name={`${name}.selected`}
      baseName={name}
      label={label}
      hint={payload?.hint}
      options={options}
      disabled={disabled}
      validate={required && validations.required(translationText.required)}
      otherValidate={required && validations.required(translationText.required)}
      margin={margin}
      onChange={onChange}
      allowClearSelection
      optional={optional}
    />
  )
}

export default RadioCitizenField

RadioCitizenField.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  payload: PropTypes.object,
  required: PropTypes.bool,
  optional: PropTypes.bool,
  manualRequest: PropTypes.bool
}
